import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { schedularAnnouncementActions } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';
const {
  GET_ALL_ANNOUNCEMENTS_REQUEST,
  GET_ALL_ANNOUNCEMENTS_LOADING,
  GET_ALL_ANNOUNCEMENTS_SUCCESS,
  GET_ALL_ANNOUNCEMENTS_FAILURE,
} = schedularAnnouncementActions;

function* getSchedularAnnouncements(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_ALL_ANNOUNCEMENTS_LOADING });
    const response = yield call(therapistService.getAllAnnouncements, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_ALL_ANNOUNCEMENTS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_ALL_ANNOUNCEMENTS_FAILURE, payload: error });
  }
}

function* getSchedularAnnouncementsSaga() {
  yield takeEvery(GET_ALL_ANNOUNCEMENTS_REQUEST, getSchedularAnnouncements);
}

export default getSchedularAnnouncementsSaga;
